import { render } from "./sf-sidepane.vue?vue&type=template&id=beea88d1"
import script from "./sf-sidepane.vue?vue&type=script&lang=js"
export * from "./sf-sidepane.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__